var prijsPerStuk = 0;
var basisPrijs = 0;
var timeoutEvent = false;
var url = window.location.href;

function updatePrices(scrollIfDone, timeout)
{
    if (typeof(scrollIfDone) == "undefined")
    {
        scrollIfDone = false;
    }
    if (typeof(timeout) == "undefined")
    {
        timeout = false;
    }

    var vierkanteMeter = getVierkanteMeter();
    var aantal = getAantal();
    if (vierkanteMeter)
    {
        var producten_materiaal_id = getMateriaalId();
        if (timeout)
        {
            if (timeoutEvent)
            {
                clearTimeout(timeoutEvent);
            }
            timeoutEvent = setTimeout(function(){
                getPrijsPerStuk(vierkanteMeter, producten_materiaal_id, scrollIfDone);
                timeoutEvent = false;
            }, timeout);
        }
        else
        {
            getPrijsPerStuk(vierkanteMeter, producten_materiaal_id, scrollIfDone);
        }
    }
    else
    {
        resetStaffelPrijzen();
        resetPrijs();
    }
}

var updating = false;
function updateFinalePrice(scrollIfDone)
{
    if (typeof(scrollIfDone) == "undefined")
    {
        scrollIfDone = false;
    }
    var vierkanteMeter = getVierkanteMeter();
    var aantal = getAantal();
    var producten_materiaal_id = getMateriaalId();
    if (vierkanteMeter && aantal)
    {
        getPrijsGekozenAantal(aantal, vierkanteMeter, producten_materiaal_id);
        if (allesIsDone())
        {
            if (scrollIfDone)
            {
                scrollProductBestellen();
            }
        }
    }
}

function getPrijsPerStuk(vierkanteMeter, producten_materiaal_id, scrollIfDone)
{
    if (typeof(scrollIfDone) == "undefined")
    {
        scrollIfDone = false;
    }
    if (vierkanteMeter !== false)
    {
        updateStaffelPrijzen();
        var aantal = getAantal();
        if (aantal)
        {
            getPrijsGekozenAantal(aantal, vierkanteMeter, producten_materiaal_id);
            if (allesIsDone())
            {
                if (scrollIfDone)
                {
                    scrollProductBestellen();
                }
            }
        }
    }
    else
    {
        return false;
    }
}

function getPrijsGekozenAantal(aantal, vierkanteMeter, producten_materiaal_id)
{
    if (aantal !== false && vierkanteMeter !== false)
    {
        $.ajax({
            type: 'post',
            dataType: 'json',
            url: url,
            data: { action: 'getPrijsGekozenAantal', aantal:aantal, formaat: getHeightWidth(), vierkanteMeter: vierkanteMeter, producten_materiaal_id: producten_materiaal_id},
            success: function(data)
            {
                updatePrijs(data.prijsexclusief, data.prijsinclusief);
            }
        });
    }
    else
    {
        return false;
    }

}

function updateStaffelPrijzen()
{
    var producten_materiaal_id = getMateriaalId();
    var vierkanteMeter = getVierkanteMeter();
    $('span[data-staffelprijs="true"]').each(function(){
        var aantal = $(this).attr('data-aantal');
        var korting = $(this).attr('data-kort');
        $.ajax({
            type: 'post',
            dataType: 'json',
            url: url,
            context: $(this),
            data: { action: 'getPrijsGekozenAantal', aantal:aantal, formaat: getHeightWidth(), vierkanteMeter: vierkanteMeter, producten_materiaal_id: producten_materiaal_id},
            success: function(data)
            {
                $(this).html('&euro; ' + number_format(data.prijsexclusief,2,',', '.'));
                var korting = parseFloat($(this).attr('data-kort'));
                if (korting > 0)
                {
                    var elem = $('.product-optie-radio-item-oudeprijs[data-oplage="' + $(this).attr('data-oplage') + '"]');
                    var oudePrijs = data.prijsexclusief / (100 - korting) * 100;
                    elem.html('&euro; ' + number_format(oudePrijs,2,',', '.')).show();
                }
            }
        });
    });
    updateCustomAantal();
}

function updateCustomAantal(e)
{
    var max = $(e).data('max');
    if($(e).val() > max) $(e).val(max);
    var producten_materiaal_id = getMateriaalId();
    var vierkanteMeter = getVierkanteMeter();
    urlFormatter();
    if (vierkanteMeter && parseFloat($('#oplage-optie-custom-invoer').val()) > 0)
    {
        var aantal = $('#oplage-optie-custom-invoer').val();
        $.ajax({
            type: 'post',
            dataType: 'json',
            url: url,
            data: { action: 'getPrijsGekozenAantal', aantal:aantal, formaat: getHeightWidth(), vierkanteMeter: vierkanteMeter, producten_materiaal_id: producten_materiaal_id},
            success: function(data)
            {
                $('#oplage-optie-custom-prijs').html('&euro; ' + number_format(data.prijsexclusief,2,',', '.'));
            }
        });
    }
    else
    {
        $('#oplage-optie-custom-prijs').html('');
    }
}

function resetStaffelPrijzen()
{
    $('span[data-staffelprijs="true"]').html('');
}

function resetPrijs()
{
    $('.product-bestellen-blok-prijs-rechts-excl').html('');
    $('.product-bestellen-blok-prijs-rechts-incl').html('');
    $('#kies-formaat-blok .kies-formaat-blok-prijs').html('');
    $('#lbl-prijs').hide();
    updateSamenvatting('knop-toevoegen', 0);
}

function getHeightWidth() {
    var formaatRadio = $(':input[name="producten_formaat_id"]:checked');
    var height = $(':input[name="custom_formaat_hoogte"]').val();
    var width = $(':input[name="custom_formaat_breedte"]').val();

    return JSON.stringify({
        width: width,
        height: height,
        custom: (formaatRadio.val() == 'custom')
    });
}

function getVierkanteMeter()
{
    var formaatRadio = $(':input[name="producten_formaat_id"]:checked');
    if (typeof(formaatRadio.val()) !== "undefined")
    {
        if (formaatRadio.val() == 'custom')
        {
            if ($(':input[name="custom_formaat_hoogte"]').val().length > 0 && $(':input[name="custom_formaat_breedte"]').val().length > 0)
            {
                updateSamenvatting('formaat', 1, $(':input[name="custom_formaat_hoogte"]').val(), $(':input[name="custom_formaat_breedte"]').val());
                var vierkanteMeter = ( parseInt($(':input[name="custom_formaat_hoogte"]').val()) * parseInt($(':input[name="custom_formaat_breedte"]').val()) / 1000000 )
                if((35 * 35) / 1000000 > vierkanteMeter) vierkanteMeter = (35 * 35) / 1000000;
                return vierkanteMeter;
            }
            else
            {
                updateSamenvatting('formaat', 0);
            }
        }
        else
        {
            updateSamenvatting('formaat', 1, formaatRadio.attr('data-hoogte'), formaatRadio.attr('data-breedte'));
            return ( parseInt(formaatRadio.attr('data-hoogte')) * parseInt(formaatRadio.attr('data-breedte')) / 1000000 );
        }
    }
    return false;
}

function getFormaat(HoogteOrBreedte)
{
    var formaatRadio = $(':input[name="producten_formaat_id"]:checked');
    if (typeof(formaatRadio.val()) !== "undefined")
    {
        if (formaatRadio.val() == 'custom')
        {
            if ($(':input[name="custom_formaat_hoogte"]').val().length > 0 && $(':input[name="custom_formaat_breedte"]').val().length > 0)
            {
                if (HoogteOrBreedte == 'hoogte')
                {
                    return $(':input[name="custom_formaat_hoogte"]').val();
                }
                else
                {
                    return $(':input[name="custom_formaat_breedte"]').val();
                }
            }
        }
        else
        {
            if (HoogteOrBreedte == 'hoogte')
            {
                return formaatRadio.attr('data-hoogte');
            }
            else
            {
                return formaatRadio.attr('data-breedte');
            }
        }
    }
    return false;
}

function getAantal()
{
    var aantalRadio = $(':input[name="opties-oplage"]:checked');
    if (typeof(aantalRadio.val()) !== "undefined")
    {
        if (aantalRadio.val() == 'custom')
        {
            if ($(':input[name="custom-aantal"]').val().length > 0)
            {
                updateSamenvatting('aantal', 1, $(':input[name="custom-aantal"]').val());
                $('#oplage-aantal').html($(':input[name="custom-aantal"]').val());
                return ( parseInt($(':input[name="custom-aantal"]').val()) );
            }
            else
            {
                updateSamenvatting('aantal', 0);
            }
        }
        else
        {
            updateSamenvatting('aantal', 1, aantalRadio.val());
            return ( aantalRadio.val() );
        }
    }
    else
    {
        updateSamenvatting('aantal', 0);
    }
    return false;
}

function getMateriaalId()
{
    if ($(':input[name="producten_materiaal_id"]:checked').length > 0)
    {
        return  $(':input[name="producten_materiaal_id"]:checked').val();
    }
    return false;
}

function getBelijmingId()
{
    if ($(':input[name="producten_belijming_id"]:checked').length > 0)
    {
        return $(':input[name="producten_belijming_id"]:checked').val();
    }
    return false;
}

function getAfwerkingId()
{
    if ($(':input[name="producten_afwerking_id"]:checked').length > 0)
    {
        return $(':input[name="producten_afwerking_id"]:checked').val();
    }
    return false;
}

function updatePrijs(prijsExclusief, prijsInclusief)
{
    $('.product-bestellen-blok-prijs-rechts-excl').html('&euro; ' + number_format(prijsExclusief, 2, ',', '.'));
    $('.product-bestellen-blok-prijs-rechts-incl').html( '&euro; ' + number_format(prijsInclusief, 2, ',', '.')+ ' incl. btw');
    $('#kies-formaat-blok .kies-formaat-blok-prijs').html('&euro; ' + number_format(prijsExclusief, 2, ',', '.'));
    $('#lbl-prijs').show();
}

function updateSamenvatting(veld, tonen, waarde1, waarde2)
{
    switch (veld)
    {
        case 'formaat':
            if (tonen)
            {
                $('#samenv-formaat').show().find('.product-bestellen-blok-tekst-rechts').html(waarde2 + ' x ' + waarde1 + ' mm');
                $('#zijkant-formaat').html(waarde2 + ' x ' + waarde1 + ' mm');
                $('#zijkant-formaat').parents('.kies-formaat-blok-regel').find('.vinkje').removeClass('hidden');
                $('#zijkant-formaat').attr('data-afgehandeld', 'true');

            }
            else
            {
                $('#samenv-formaat').show().find('.product-bestellen-blok-tekst-rechts').html('<i>Kies formaat</i>');
                $('#zijkant-formaat').html($('#zijkant-formaat').attr('data-initial'));
                $('#zijkant-formaat').parents('.kies-formaat-blok-regel').find('.vinkje').addClass('hidden');
                $('#zijkant-formaat').attr('data-afgehandeld', 'false');
            }
            break;
        case 'aantal':
            if (tonen)
            {
                $('#samenv-oplage').show().find('#oplage-aantal').html(waarde1);
                $('#zijkant-oplage').html(waarde1);
                $('#zijkant-oplage').parents('.kies-formaat-blok-regel').find('.vinkje').removeClass('hidden');
                $('#zijkant-oplage').attr('data-afgehandeld', 'true');
            }
            else
            {
                $('#samenv-oplage').show().find('#oplage-aantal').html('<i>Kies oplage</i>');
                $('#zijkant-oplage').html($('#zijkant-oplage').attr('data-initial'));
                $('#zijkant-oplage').parents('.kies-formaat-blok-regel').find('.vinkje').addClass('hidden');
                $('#zijkant-oplage').attr('data-afgehandeld', 'false');
            }
            break;
        case 'materiaal':
            $('#samenv-materiaal').hide();
            if (tonen)
            {
                $('#samenv-materiaal').show().find('.product-bestellen-blok-tekst-rechts').html(waarde1);
                $('#zijkant-materiaal').html(waarde1);
                $('#zijkant-materiaal').parents('.kies-formaat-blok-regel').find('.vinkje').removeClass('hidden');
                $('#zijkant-materiaal').attr('data-afgehandeld', 'true');
            }
            break;
        case 'belijming':
            $('#samenv-belijming').hide();
            if (tonen)
            {
                $('#samenv-belijming').show().find('.product-bestellen-blok-tekst-rechts').html(waarde1);
                $('#zijkant-belijming').html(waarde1);
                $('#zijkant-belijming').parents('.kies-formaat-blok-regel').find('.vinkje').removeClass('hidden');
                $('#zijkant-belijming').attr('data-afgehandeld', 'true');
            }
            break;
        case 'afwerking':
            $('#samenv-afwerking').hide();
            if (tonen)
            {
                $('#samenv-afwerking').show().find('.product-bestellen-blok-tekst-rechts').html(waarde1);
                $('#zijkant-afwerking').html(waarde1);
                $('#zijkant-afwerking').parents('.kies-formaat-blok-regel').find('.vinkje').removeClass('hidden');
                $('#zijkant-afwerking').attr('data-afgehandeld', 'true');
            }
            break;
        case 'knop-toevoegen':
            $('.toevoegen-btn').hide();
            if (tonen)
            {
                $('.toevoegen-btn').show();
            }
            break;
    }
    updateZijkant();
    if (veld != 'knop-toevoegen')
    {
        allesIsDone();
    }
}

var huidigeStap = 1;
var animeren = false;
function updateZijkant()
{
    setTimeout(function(){
        var maxStep = 5;
        if ($('#wrapper-step-6').length > 0)
        {
            maxStep = 6;
        }
        if (!animeren)
        {
            var currentStepElement = $('[data-stap="' + (huidigeStap) + '"]');
            if (currentStepElement.text() != currentStepElement.attr('data-initial') )
            {
                var nextStepWrapper = false;
                $('.kies-formaat-blok-regel-tekst').each(function(){
                    if ($(this).attr('data-afgehandeld') == 'false' && nextStepWrapper === false)
                    {
                        var nextStepElement = $(this);
                        huidigeStap = parseInt(nextStepElement.attr('data-stap') - 1);
                        nextStepWrapper = $('#wrapper-step-' + nextStepElement.attr('data-stap'));
                    }
                });
                if (!nextStepWrapper)
                {
                    huidigeStap = maxStep;
                    nextStepWrapper = $('#wrapper-step-' + maxStep);
                }
                if (nextStepWrapper)
                {
                    $('.product-kies-onderdeel-active').removeClass('product-kies-onderdeel-active');
                    $('.pijl-active').remove();
                    nextStepWrapper.find('.product-kies-onderdeel').addClass('product-kies-onderdeel-active');
                    nextStepWrapper.find('.product-kies-onderdeel').prepend('<span class="pijl-active"><img src="images/pijl-groen-onder.png" alt="Pijl"></span>');

                    if (huidigeStap <= maxStep)
                    {
                        animeren = true;
                        $('html,body').animate({
                            scrollTop: nextStepWrapper.offset().top - 60
                        }, function(){
                            animeren = false;
                        });

                        console.log('huidig', huidigeStap);
                        console.log('max', maxStep);

                        if(huidigeStap <= maxStep) {
                            var stap = huidigeStap;
                            stap++;
                            if(stap >= 6) stap = 5;
                            $('#kies-formaat-blok').animate({
                                marginTop: ($('#wrapper-step-' + stap).offset().top - $('.content-sub-product-links-onder').offset().top) - 20
                            }, 400);
                        }
                    }
                    $('.kies-formaat-blok-titel').html(nextStepWrapper.find('.product-kies-onderdeel-tekst').html());
                }
            }
        }
    }, 50);
}

function addToWinkelwagen()
{
    $.fancybox.showLoading();
    $.ajax({
        url: url,
        type: 'post',
        data: {action: 'ToevoegenWinkelwagen', aantal: getAantal(), productenMateriaalId: getMateriaalId(), productenBelijmingId: getBelijmingId(), productenAfwerkingId: getAfwerkingId(), formaatBreedte: getFormaat('breedte'), formaatHoogte: getFormaat('hoogte') },
        success: function(data)
        {
            //$.fancybox('<h1>Toevoegen winkelwagen</h1><p>Het product is succesvol toegevoegd aan de winkelwagen</p><a href="webshop/winkelwagen/1/" class="standaard-button">Naar de winkelwagen</a><span class="of-keuze">of</span><a href="stickers-ontwerpen/' + data + '/" class="standaard-button ontwerpmodule-btn">Naar de ontwerpmodule</a><br /><a class="verder-winkelen" href="javascript:;">verder winkelen</a>');
            $.fancybox('<h1>Toevoegen winkelwagen</h1><p>Het product is succesvol toegevoegd aan de winkelwagen</p><a href="webshop/winkelwagen/2/" class="standaard-button">Naar de winkelwagen</a><span class="of-keuze">of</span><a class="verder-winkelen" href="javascript:;">verder winkelen</a>');
            $.fancybox.hideLoading();
            updateWinkelwagenTop();
        }
    })
}

function updateWinkelwagenTop()
{
    $.ajax({
        type: 'post',
        url: url,
        data: { 'do': 'showComponent', 'args[naam]' : 'WinkelwagenTop', 'module' : 'Webshop'},
        success: function(data)
        {
            $('#top-rechts-winkelwagen').replaceWith(data);
        }
    });
}

function scrollProductBestellen()
{
    $('html, body').animate({
        scrollTop: $("#wrapper-step-5").offset().top
    }, 600);
}

function allesIsDone()
{
    var errors = 0;
    $('.kies-samenvatting-blok-regel').each(function(){
        var vinkje = $(this).find('.vinkje');
        if (vinkje.hasClass('hidden'))
        {
            errors++;
        }
    });
    if (errors > 0)
    {
        updateSamenvatting('knop-toevoegen', 0);
        return false;
    }
    else
    {
        updateSamenvatting('knop-toevoegen', 1);
        return true;
    }
}